import { Container, Graphics } from "pixi.js"
import CountDownDisplay from "./CountDownDisplay"
import PlayerInfoDisplay from "./PlayerInfoDisplay"
import { PlayerId } from "$types"
import { INFO_BAR_HEIGHT, SCALE_FACTOR, SCREEN_WIDTH } from "./config"

export default class InfoBar extends Container {
  static InfoBarHeight = INFO_BAR_HEIGHT * SCALE_FACTOR
  static InfoBarWidth = SCREEN_WIDTH

  public countDownDisplay: CountDownDisplay
  public playerInfoDisplays: {
    [key: number]: PlayerInfoDisplay
  }

  constructor(params: { x: number, y: number }) {
    super({
      x: params.x,
      y: params.y
    })

    const background = new Graphics()
      .rect(0, 0, InfoBar.InfoBarWidth, InfoBar.InfoBarHeight)
      .fill(0xf78402)

    this.addChild(
      background
    )

    this.countDownDisplay = new CountDownDisplay({
      x: 0,
      y: 0
    })

    const yOffset = (InfoBar.InfoBarHeight - this.countDownDisplay.height) / 2

    this.countDownDisplay.x = (InfoBar.InfoBarWidth - this.countDownDisplay.width) / 2
    this.countDownDisplay.y = yOffset

    this.addChild(this.countDownDisplay)

    this.playerInfoDisplays = [1, 2, 3, 4].reduce<{ [key: number]: PlayerInfoDisplay }>((acc, playerId, i) => {
      const x = [1, 2].includes(playerId) ?
        20 * SCALE_FACTOR + i * 40 * SCALE_FACTOR :
        (InfoBar.InfoBarWidth + this.countDownDisplay.width) / 2 + 20 * SCALE_FACTOR + (i - 2) * 40 * SCALE_FACTOR

      acc[playerId] = new PlayerInfoDisplay({
        x,
        y: yOffset,
        playerId: playerId as PlayerId,
        status: "Inactive"
      })

      this.addChild(acc[playerId])
      return acc
    }, {})

  }
}
